export default "__VITE_ASSET__BwlFZwK5__"